import * as types from './doctorTypes';

const defaultFormValue = {
  name: { value: '-1' },
  subject_id: { value: '-1' },
  dayofweek: { value: '-1' },
  sex: { value: '-1' },
  role: { value: '-1' },
};

const initialState = {
  loading: false,
  rows: [],
  specialist: [],
  totalRows: 0,
  pageIndex: 0,
  pageSize: 10,
  hasMore: true,
  error: '',
  info: { ...defaultFormValue },
  selectedDoctor: '',
};

export default function doctorReducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.GET_ALL_DOCTOR_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.SET_PAGE_INDEX:
      return {
        ...state,
        pageIndex: action.pageIndex,
      };
    case types.GET_ALL_DOCTOR_LIST_SUCCESS: {
      const { rows, totalRows } = action;
      /* check hasMore */
      const length = rows.length + state.rows.length;
      let hasMore = state.hasMore;
      if (length === totalRows) {
        hasMore = false;
      }
      return {
        ...state,
        loading: false,
        rows: [...state.rows, ...rows],
        pageIndex: state.pageIndex + 1,
        totalRows: totalRows,
        hasMore,
      };
    }

    case types.GET_ALL_DOCTOR_LIST_DESKTOP_SUCCESS: {
      const { rows, totalRows } = action;
      return {
        ...state,
        loading: false,
        rows: [...rows],
        pageIndex: state.pageIndex + 1,
        totalRows: totalRows,
      };
    }

    case types.GET_ALL_DOCTOR_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case types.RESET_PAGE_INDEX:
      return {
        ...state,
        ...initialState,
        // pageIndex: 0,
        // pageSize: 10,
        // rows: [],
        // specialist: [],
        // hasMore: true,
        // info: { ...defaultFormValue },
      };
    case types.GET_ALL_DOCTOR_SPECIALIST_SUCCESS:
      return {
        ...state,
        specialist: [{ id: -1, name: 'Chuyên Khoa' }, ...action.subject],
      };

    case types.DOCTOR_FORM_SAVE_FIELD:
      // eslint-disable-next-line no-case-declarations
      const mergeState = {
        ...state,
        rows: [],
        pageIndex: 0,
        hasMore: true,
        info: {
          ...state.info,
          ...action.payload,
        },
      };
      return mergeState;
    case types.DOCTOR_FORM_SAVE_FIELD_DESKTOP: {
      const mergeState = {
        ...state,
        info: {
          ...state.info,
          ...action.payload,
        },
      };
      return mergeState;
    }
    case types.SELECT_DOCTOR:
      return { ...state, selectedDoctor: action.doctor };

    case types.RESET_SELECTED_DOCTOR:
      return { ...state, selectedDoctor: '' };

    default:
      return state;
  }
}
